// extracted by mini-css-extract-plugin
export default {"title":"title___tXz6H"};